import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import "semantic-ui-css/semantic.css";
import React, { Component } from "react";
import subsection_style from "./style.js";

// import teaser from "./images/Teaser-SinNeRF.drawio.jpg";
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility,
} from "semantic-ui-react";

// import MyCarousel from "./Carousel.js";

const Abstract = ({ mobile }) => (
  <div>
    {/* <MyCarousel mobile={mobile} />

    <Image src={teaser} style={subsection_style}></Image>
    <p>
      <b>TL;DR:</b> Given only a single reference view as input, our novel
      semi-supervised framework trains a neural radiance field effectively. In
      contrast, previous method shows inconsistent geometry when synthesizing
      novel views.
    </p> */}
    <Header as="h2" textAlign="center" style={subsection_style}>
      Abstract
    </Header>
    <p>
    Have you ever imagined how it would look if we placed new objects into paintings? 
For example, what would it look like if we placed a basketball into Claude Monet's <i>``Water Lilies, Evening Effect''</i>? <br></br>
We propose <b>Ref</b>erence-based <b>Paint</b>erly Inpainting, a novel task that crosses the wild reference domain gap and implants novel objects into artworks.
Although previous works have examined reference-based inpainting, they are not designed for large domain discrepancies between the target and the reference, such as inpainting an artistic image using a photorealistic reference.
This paper proposes a novel diffusion framework, dubbed RefPaint, to ``inpaint more wildly'' by taking such references with large domain gaps.
Built with an image-conditioned diffusion model, we introduce a ladder-side branch and a masked fusion mechanism to work with the inpainting mask. 
By decomposing the CLIP image embeddings at inference time, one can manipulate the strength of semantic and style information with ease.
Experiments demonstrate that our proposed RefPaint framework produces significantly better results than existing methods. Our method enables creative painterly image inpainting with reference objects that would otherwise be difficult to achieve.
    </p>
  </div>
);

export default Abstract;
